/**
 * Super-admin user-management calls. Kept separate from `mfaService` — resetting
 * a password is account administration, not a second-factor operation.
 */
import { apiRequest } from './api';

export interface AdminPasswordResetResult { ok: boolean; password: string; email: string | null }

/**
 * Set a new password for a user and return it once. Omit `password` to have the
 * server generate a strong, typeable one (the usual assisted-support flow).
 */
export const adminResetUserPassword = (uid: string, password?: string) =>
  apiRequest<AdminPasswordResetResult>(
    `/admin/users/${uid}/password/reset`,
    { method: 'POST', body: JSON.stringify(password ? { password } : {}) },
  );

export interface AdminUserActivity { lastSignInAt: number | null; lastActiveAt: number | null }

/** Last sign-in / last active per user (epoch ms), keyed by UID, from Firebase Auth. */
export const getAdminUsersActivity = () =>
  apiRequest<{ activity: Record<string, AdminUserActivity> }>('/admin/users/activity');
